<div class="overlay {{ currentOverlay.color }}" *ngIf="currentOverlay.show" (click)="hide()" [@fade]>
  <app-spinner *ngIf="currentOverlay.spinner"></app-spinner>
</div>

